import React, { Suspense } from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import ModernLayout from './ModernLayout'
import POSLayout from './POSLayout'
import RootRoutes from '../../routes/RootRoutes'
import ProtectedRoute from '../../auth/ProtectedRoute'
import { motion } from 'framer-motion'
import CenteredSpinner from '../CenteredSpinner'

const PageTransition = ({ children }) => (
    <motion.div
        initial={{ opacity: 0, y: -40 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -40 }}
        transition={{ duration: 0.2, ease: 'easeInOut' }}
        style={{ height: '100%' }}
    >
        {children}
    </motion.div>
)

const LoonsLayout = () => {
    const location = useLocation();
    const isPOSRoute = location.pathname.startsWith("/pos");
    const isKDSRoute = location.pathname.startsWith("/kds");
    const isGuestHubAdminRoute = location.pathname.startsWith("/guest-hub-admin");
    const isOpsBoardRoute = isPOSRoute || isKDSRoute || isGuestHubAdminRoute;

    // Choose layout based on route type
    const Layout = isOpsBoardRoute ? POSLayout : ModernLayout;

    return (
        <Layout>
            <PageTransition>
                <Routes>
                    {RootRoutes.map((route, i) => (
                        <Route
                            key={i}
                            path={route.path}
                            element={
                                <ProtectedRoute requiredRoles={route.auth || []}>
                                    <Suspense fallback={<CenteredSpinner />}>
                                        {isOpsBoardRoute ? (
                                            <route.component />
                                        ) : (
                                            <div style={{ zoom: 0.9 }}>
                                                <route.component />
                                            </div>
                                        )}
                                    </Suspense>
                                </ProtectedRoute>
                            }
                        />
                    ))}
                </Routes>
            </PageTransition>
        </Layout>
    )
}

export default LoonsLayout 